import { Env } from '@didi/utils'
import { noop } from '../util/tool'

// redirect 的方式对域名有限制，不在授权范围内的无法成功跳转. 由于是跳转页面的方式，所以需要在最前面引用
export default function getOpenIdRedirect(callback = noop) {
   /* istanbul ignore else */
  if (!Env.isWechat && !Env.isAlipay) {
    return
  }
  const openid = /openid=([^#]*)&?/.exec(window.location.search || '')
  const oidPath = '//common.diditaxi.com.cn/webapp/platform/oauth2/openid?redirect=' + window.encodeURIComponent(window.location.href)
  if (!openid) {
    window.location.replace(oidPath)
  } else {
    callback(null, openid)
  }
}
